import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// One-time unregister of service worker without reload
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      registration.unregister();
    });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Temporarily disabled service worker registration
// serviceWorkerRegistration.register({
//   onSuccess: (registration) => {
//     console.log('PWA registration successful');
//     // Force a reload once after installation to ensure the latest version
//     if (!localStorage.getItem('pwa-installed')) {
//       localStorage.setItem('pwa-installed', 'true');
//       window.location.reload();
//     }
//   },
//   onUpdate: (registration) => {
//     const waitingServiceWorker = registration.waiting;
//     if (waitingServiceWorker) {
//       waitingServiceWorker.addEventListener("statechange", (event) => {
//         if ((event.target as ServiceWorker).state === "activated") {
//           window.location.reload();
//         }
//       });
//       waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
//     }
//   },
// }); 